export const combineSets = (...iterables) => {
  if (iterables.some(iter => !((iter instanceof Set) || Array.isArray(iter)))) {
    throw new Error('combineSets must be called with Sets or arrays')
  }
  return iterables.reduce(
    (set, iter) => new Set([...set, ...iter])
  )
}
